<div>
    <a href="javascript:void(0)" (click)="onLinkClick()" *ngIf="params.data && params.data.isMultipleChange">
        {{params.value}}
    </a>
    <span *ngIf="params.data && !params.data.isMultipleChange"> {{params.value}} </span>
</div>